import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import {
  TITLE_TICKET,
  TICKET_MESSAGE_INNER_FORMS,
} from '../../../constants/texts';
import { useTicketInnerFormsStyles } from './styles';

const TicketConfirmationText = ({ ...props }) => {
  const { ticketId, request } = props;
  const classes = useTicketInnerFormsStyles();
  return (
    <React.Fragment>
      <Typography className={classes.title}>{TITLE_TICKET(request)}</Typography>
      <Typography className={classes.subtitle}>
        Tu número de solicitud es:
      </Typography>
      <Typography className={classes.purpleDetail}>{ticketId}</Typography>
      <Typography className={classes.bodyText}>
        {TICKET_MESSAGE_INNER_FORMS}
      </Typography>
    </React.Fragment>
  );
};

TicketConfirmationText.propTypes = {
  ticketId: PropTypes.string,
  request: PropTypes.bool,
};

export default TicketConfirmationText;
